import { createAction, props } from "@ngrx/store";
import { GenericApiData } from "src/components/shared-components/class/general-classes/generic-api-data";
import { Notific } from "src/model/class/general classes/notific";
import { NotificationStoreAction } from "src/components/shared-components/enum/enumStoreAction";

/**
 * Reseet notification state and unset key storage
 */
export const notificationUnsetKeyStorage = createAction(
  NotificationStoreAction.NOTIFICATION_UNSET_KEY_STORAGE
);

/**
 * Action fired when request to load start
 */
export const notificationLoadInitStartAction = createAction(
  NotificationStoreAction.NOTIFICATION_LOAD_INIT_START
);

/**
 * Save notification into object action
 */
export const notificationSaveIntoStorageAction = createAction(
  NotificationStoreAction.NOTIFICATION_SAVE_INTO_STORAGE,
  props<{ notificationObject: GenericApiData; error: boolean }>()
);

/**
 * Action to load full list of notification
 */
export const notificationLoadListFromApiAction = createAction(
  NotificationStoreAction.NOTIFICATION_LOAD_FROM_API
);

/**
 * Action to load last modified list of notification
 */
export const notificationLoadLastModifiedFromApiAction = createAction(
  NotificationStoreAction.NOTIFICATION_LOAD_LAST_MODIFIED_FROM_API,
  props<{ notifications: GenericApiData }>()
);

/**
 * Action success notification load success
 */
export const notificationLoadSuccessAction = createAction(
  NotificationStoreAction.NOTIFICATION_LOAD_SUCCESS,
  props<{ notificationObject: GenericApiData }>()
);

/**
 * Action success notification load error
 */
export const notificationLoadErrorAction = createAction(
  NotificationStoreAction.NOTIFICATION_LOAD_ERROR,
  props<{ notificationObject: GenericApiData }>()
);

/**
 * Action insert new notification
 */
export const notificationInsertAction = createAction(
  NotificationStoreAction.NOTIFICATION_INSERT_NOTIFICATION,
  props<{ idNotification: number }>()
);

/**
 * Action delete notification
 */
export const notificationDeleteAction = createAction(
  NotificationStoreAction.NOTIFICATION_DELETE_NOTIFICATION,
  props<{ idNotification: number }>()
);

/**
 * Action to update notification
 */
export const notificationUpdateAction = createAction(
  NotificationStoreAction.NOTIFICATION_UPDATE_NOTIFICATION,
  props<{ idNotification: number }>()
);

/**
 * Action insert new notification complete
 */
export const notificationInsertCompleteAction = createAction(
  NotificationStoreAction.NOTIFICATION_INSERT_NOTIFICATION_COMPLETE,
  props<{ newNotification: Notific }>()
);

/**
 * Action delete notification complete
 */
export const notificationDeleteCompleteAction = createAction(
  NotificationStoreAction.NOTIFICATION_DELETE_NOTIFICATION_COMPLETE,
  props<{ idNotification: number }>()
);

/**
 * Action to update notification complete
 */
export const notificationUpdateCompleteAction = createAction(
  NotificationStoreAction.NOTIFICATION_UPDATE_NOTIFICATION_COMPLETE,
  props<{ updatedNotification: Notific }>()
);
